var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 button-edit d-flex justify-content-center pointer",attrs:{"variant":"link"},on:{"click":_vm.handleEditItem}},[_c('feather-icon',{attrs:{"icon":"Edit2Icon","size":"18"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }